"use client";

import { FC, useEffect, ReactNode, MouseEvent } from "react";
import styles from "./card.module.css";

// Define props interface
interface CardProps {
  divBlock: ReactNode;
}

// MouseMove handler
const handleOnMouseMove = (e: MouseEvent<HTMLDivElement>) => {
  const target = e.currentTarget;
  const rect = target.getBoundingClientRect();

  const x = e.clientX - rect.left;
  const y = e.clientY - rect.top;

  target.style.setProperty("--mouse-x", `${x}px`);
  target.style.setProperty("--mouse-y", `${y}px`);
};

const Card: FC<CardProps> = ({ divBlock }) => {
  useEffect(() => {
    const cardWrappers = document.querySelectorAll(`.${styles["card-wrapper"]}`);

    cardWrappers.forEach((navbar) => {
      navbar.addEventListener("mousemove", handleOnMouseMove as any);
    });

    return () => {
      cardWrappers.forEach((navbar) => {
        navbar.removeEventListener("mousemove", handleOnMouseMove as any);
      });
    };
  }, []);

  return (
    <div className={styles["card-wrapper"]}>
      {divBlock}
      <div className={styles["card-border"]}></div>
      <div className={styles["card-bg"]}></div>
    </div>
  );
};

export default Card;
